
            import { i18n, t } from './scripts/i18n.js';

            let currentGalleryItems = {};

            // Initialize i18n system
            async function initializeI18n() {
                try {
                    // Check URL parameter first
                    const urlParams = new URLSearchParams(window.location.search);
                    const urlLang = urlParams.get('lang');

                    console.log('Gallery page initializing with URL lang:', urlLang);

                    await i18n.initialize();

                    console.log('Gallery i18n initialized with language:', i18n.getCurrentLanguage());

                    // If URL has a language parameter and it's different from current, change it
                    if (urlLang && urlLang !== i18n.getCurrentLanguage()) {
                        console.log('Changing language to URL parameter:', urlLang);
                        await i18n.changeLanguage(urlLang);
                    }

                    // Load gallery items translations (after language is set)
                    loadGalleryTranslations();

                    // Update all translatable elements (after translations are loaded)
                    updatePageTranslations();

                    // Set up language selector
                    setupLanguageSelector();

                    // Update HTML lang attribute
                    i18n.updateHtmlLang();

                    // Update meta tags
                    updateMetaTags();
                } catch (error) {
                    console.error('Failed to initialize i18n:', error);
                }
            }

            function loadGalleryTranslations() {
                console.log('Loading gallery translations for language:', i18n.getCurrentLanguage());

                const galleryItems = [
                    'classic45',
                    'narrow30',
                    'wide60',
                    'shallowDepth',
                    'deepRecursion',
                    'largeBase',
                    'smallBase',
                    'perfectBalance',
                    'extremeNarrow',
                    'extremeWide',
                    'darkTheme',
                    'monochromaticBlue',
                ];

                galleryItems.forEach(item => {
                    const title = t(`gallery.items.${item}.title`);
                    const description = t(`gallery.items.${item}.description`);

                    console.log(`Gallery item ${item}: title="${title}", description="${description}"`);

                    currentGalleryItems[item] = {
                        title: title,
                        description: description,
                    };
                });
            }

            function updatePageTranslations() {
                console.log('Updating page translations for language:', i18n.getCurrentLanguage());

                // Update all elements with data-i18n attributes
                document.querySelectorAll('[data-i18n]').forEach(element => {
                    const key = element.getAttribute('data-i18n');
                    const params = element.getAttribute('data-i18n-params');

                    let parsedParams = {};
                    if (params) {
                        try {
                            parsedParams = JSON.parse(params);
                        } catch (e) {
                            console.warn('Invalid i18n params:', params);
                        }
                    }

                    const translation = t(key, parsedParams);

                    console.log(`Translating "${key}" to "${translation}"`);

                    if (element.tagName === 'TITLE') {
                        element.textContent = translation;
                    } else {
                        element.textContent = translation;
                    }
                });
            }

            function updateMetaTags() {
                const lang = i18n.getCurrentLanguage();

                // Update meta description
                const metaDescription = document.querySelector('meta[name="description"]');
                if (metaDescription) {
                    metaDescription.setAttribute('content', t('gallery.meta.description'));
                }

                // Update Open Graph title and description
                const ogTitle = document.querySelector('meta[property="og:title"]');
                if (ogTitle) {
                    ogTitle.setAttribute('content', t('gallery.meta.title'));
                }

                const ogDescription = document.querySelector('meta[property="og:description"]');
                if (ogDescription) {
                    ogDescription.setAttribute('content', t('gallery.meta.description'));
                }

                // Update Twitter Card title and description
                const twitterTitle = document.querySelector('meta[name="twitter:title"]');
                if (twitterTitle) {
                    twitterTitle.setAttribute('content', t('gallery.meta.title'));
                }

                const twitterDescription = document.querySelector('meta[name="twitter:description"]');
                if (twitterDescription) {
                    twitterDescription.setAttribute('content', t('gallery.meta.description'));
                }
            }

            function setupLanguageSelector() {
                const selector = document.getElementById('languageSelector');

                // Defensive check: element might not exist in some contexts
                if (!selector) {
                    console.warn('Language selector element not found, skipping setup');
                    return;
                }

                const currentLang = i18n.getCurrentLanguage();

                // Set current language as selected
                selector.value = currentLang;

                // Handle language changes
                selector.addEventListener('change', async e => {
                    const newLang = e.target.value;
                    const success = await i18n.changeLanguage(newLang);

                    if (success) {
                        // Reload gallery translations
                        loadGalleryTranslations();

                        // Update all page translations
                        updatePageTranslations();

                        // Update meta tags
                        updateMetaTags();

                        // Update HTML lang attribute
                        i18n.updateHtmlLang();

                        // Update URL parameter
                        const url = new URL(window.location);
                        url.searchParams.set('lang', newLang);
                        window.history.replaceState({}, '', url);
                    }
                });
            }

            function openLightbox(imageSrc, itemKey) {
                const lightbox = document.getElementById('lightbox');
                const lightboxImage = document.getElementById('lightbox-image');
                const lightboxCaption = document.getElementById('lightbox-caption');

                const item = currentGalleryItems[itemKey];
                if (!item) {
                    console.error('Gallery item not found:', itemKey);
                    return;
                }

                lightboxImage.src = imageSrc;
                lightboxImage.alt = item.title;
                lightboxCaption.textContent = item.title + ' - ' + item.description;

                lightbox.style.display = 'flex';

                // Close on escape key
                document.addEventListener('keydown', function (e) {
                    if (e.key === 'Escape') {
                        closeLightbox();
                    }
                });

                // Close on click outside
                lightbox.addEventListener('click', function (e) {
                    if (e.target === lightbox) {
                        closeLightbox();
                    }
                });
            }

            function closeLightbox() {
                document.getElementById('lightbox').style.display = 'none';
            }

            // Make functions globally available
            window.openLightbox = openLightbox;
            window.closeLightbox = closeLightbox;

            // Initialize when DOM is loaded
            document.addEventListener('DOMContentLoaded', initializeI18n);
        